import { render, staticRenderFns } from "./Clients.vue?vue&type=template&id=f66f93c6&scoped=true"
import script from "./Clients.vue?vue&type=script&lang=js"
export * from "./Clients.vue?vue&type=script&lang=js"
import style0 from "./Clients.vue?vue&type=style&index=0&id=f66f93c6&prod&lang=scss&scoped=true"
import style1 from "./Clients.vue?vue&type=style&index=1&id=f66f93c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66f93c6",
  null
  
)

export default component.exports